import { createPortal } from 'react-dom';

export const SchemaJsonArticle = ({
  title,
  text,
  image,
}: {
  title: string;
  text: string;
  image: string | null | undefined;
}) => {
  let textFix = '';

  if (text) {
    textFix = text.replaceAll('\n', '').replaceAll('\r', '').replaceAll('"', '\\"');
  }

  return createPortal(
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
              "@context": "http://schema.org",
              "@type": "Article",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "${window.location.href}"
              },
              "headline": "${title}",
              ${
                image
                  ? `"image": {
                "@type": "ImageObject",
                "url": "https://test-1010z.fresco.bz/${image}"
              },`
                  : ''
              }
              "datePublished": "2023-09-15T12:00:00+03:00",
              "author": {
                "@type": "Person",
                "name": "Dalli"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Dalli Service",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://dalli-service.com/favicon/apple-touch-icon.png"
                }
              },
              "articleBody": "${textFix}"
            }`,
      }}
    ></script>,
    document.head
  );
};
